import { CPP_OPT_EST_RECEIVED, CPP_OPT_RECEIVED, CPP_ACC_RECEIVED, CPP_OPT_UNLOADED } from './types'

export default function cppestimator(state = {}, action = {}){
  switch (action.type) {
    case CPP_OPT_EST_RECEIVED:
      return {
        ...state,
        estimate: action.data
      }
    case CPP_OPT_RECEIVED:
      return {
        ...state,
        optimized: action.data
      }
    case CPP_ACC_RECEIVED:
      return {
        ...state,
        accumulated: action.data
      }
    case CPP_OPT_UNLOADED:
      return {}
    default:
      return state;
  }
}
